export const tablePropsBase = {
  firstColumnLabel: 'Current',
  lastColumnLabel: 'Est. Savings',
  labelFirstRow: 'Est. monthly payment',
  labelSecondRow: 'Est. total debt cost',
  monthlyCurrent: '$750',
  monthlyAchieve: '$540',
  monthlySavings: '$210',
  totalCurrent: '$53,000',
  totalAchieve: '$20,000',
  totalSavings: '$33,000',
  badge: true,
  estSavingsColumn: true,
  estMonthlySavingsBottom: true,
  currentTime: '27 yr',
  achieveTime: '2-4 yr',
}
export const DataSectionTest = {
  current_assessment: {
    cfos: {
      payoff_info: {
        amortization: false,
        blended_interest_rate: 22.77,
        budget: {
          apply_budget: false,
          is_budget_valid: false,
          monthly_budget: 0,
        },
        cerebro_pid: 'dummy_cerebro',
        plan_start_date: '2023-12-14',
        request_id: '',
        request_schema_ver: '20231029cfos2',
        strategies: ['FIXED'],
        tradelines: [
          {
            account_type: '',
            balance: 30000,
            balance_date: '',
            credit_limit: 0,
            creditor: {
              kob: '',
              name: '',
              subscriber_code: '',
            },
            debt_calculation: {
              balance: 30000,
              calculation_type: 'REVOLVING',
              errors: [],
              interest_rate: 22.77,
              is_monthly_payment_valid: false,
              monthly_payment_updated: true,
              terms: 0,
              updated_monthly_payment: 0,
              warnings: [],
            },
            enhanced_payment_data: {
              account_condition: '',
              account_type: '',
              initial_payment_level_date: '',
              payment_status: '',
              special_comment_code: '',
            },
            high_credit: 0,
            id: '1',
            is_open: false,
            monthly_payment: 874.57,
            most_recent_delinquency_date: '',
            original_amount: 0,
            revolving_or_installment: 'R',
            rule_data: {
              category: 'credit_card_default',
              interest_rate: 22.77,
              is_collections: false,
              is_delinquent: false,
              is_valid_tradeline: true,
              min_monthly_payment: 35,
              principal_paydown_percentage: 1,
              revolving_or_installment: 'R',
              terms_months: 0,
            },
            terms: 0,
          },
        ],
      },
      payoff_plans: [
        {
          payoff: [],
          starting_total_monthly_payment: 874.57,
          strategy_type: 'FIXED',
          time_in_months: 57,
          total_amount: 49318.54,
          total_interest: 19318.54,
          tradeline_payoff: [
            {
              amount: 49318.54,
              id: '1',
              interest: 19318.54,
              interest_rate_used: 22.77,
              monthly_payment: 874.57,
              principal: 30000,
              time_in_months: 57,
            },
          ],
        },
      ],
    },
  },
  default_offers: {
    ahl_offers: [
      {
        amount: 30000,
        monthly_payment: 434.76,
        rate: 12.25,
        terms: 120,
        terms_category: '',
        total_cost: 52171,
      },
    ],
    apl_offers: [
      {
        amount: 30000,
        monthly_payment: 1534.06,
        rate: 28.21,
        terms: 24,
        terms_category: '24',
        total_cost: 36817,
      },
      {
        amount: 30000,
        monthly_payment: 1122.41,
        rate: 25.06,
        terms: 36,
        terms_category: '36',
        total_cost: 40407,
      },
      {
        amount: 30000,
        monthly_payment: 961.38,
        rate: 27.32,
        terms: 48,
        terms_category: '48',
        total_cost: 46146,
      },
      {
        amount: 30000,
        monthly_payment: 884.77,
        rate: 28.94,
        terms: 60,
        terms_category: '60',
        total_cost: 53086,
      },
    ],
    ar_offers: [
      {
        amount: 30000,
        monthly_payment: 901,
        rate: null,
        terms: 24,
        terms_category: 'offer1',
        total_cost: 21615,
      },
      {
        amount: 30000,
        monthly_payment: 549,
        rate: null,
        terms: 48,
        terms_category: 'offer2',
        total_cost: 26355,
      },
      {
        amount: 30000,
        monthly_payment: 554,
        rate: null,
        terms: 49,
        terms_category: 'offer3',
        total_cost: 27376,
      },
    ],
  },
  projected_assessment: {
    cfos: {
      payoff_info: {
        amortization: false,
        blended_interest_rate: 22.77,
        budget: {
          apply_budget: false,
          is_budget_valid: false,
          monthly_budget: 0,
        },
        cerebro_pid: 'dummy_cerebro',
        plan_start_date: '2023-12-14',
        request_id: '',
        request_schema_ver: '20231029cfos2',
        strategies: ['FIXED'],
        tradelines: [
          {
            account_type: '',
            balance: 35194,
            balance_date: '',
            credit_limit: 0,
            creditor: {
              kob: '',
              name: '',
              subscriber_code: '',
            },
            debt_calculation: {
              balance: 35194,
              calculation_type: 'REVOLVING',
              errors: [],
              interest_rate: 22.77,
              is_monthly_payment_valid: false,
              monthly_payment_updated: true,
              terms: 0,
              updated_monthly_payment: 0,
              warnings: [],
            },
            enhanced_payment_data: {
              account_condition: '',
              account_type: '',
              initial_payment_level_date: '',
              payment_status: '',
              special_comment_code: '',
            },
            high_credit: 0,
            id: '1',
            is_open: false,
            monthly_payment: 1025.98,
            most_recent_delinquency_date: '',
            original_amount: 0,
            revolving_or_installment: 'R',
            rule_data: {
              category: 'credit_card_default',
              interest_rate: 22.77,
              is_collections: false,
              is_delinquent: false,
              is_valid_tradeline: true,
              min_monthly_payment: 35,
              principal_paydown_percentage: 1,
              revolving_or_installment: 'R',
              terms_months: 0,
            },
            terms: 0,
          },
        ],
      },
      payoff_plans: [
        {
          payoff: [],
          starting_total_monthly_payment: 1025.98,
          strategy_type: 'FIXED',
          time_in_months: 57,
          total_amount: 57857.56,
          total_interest: 22663.56,
          tradeline_payoff: [
            {
              amount: 57857.56,
              id: '1',
              interest: 22663.56,
              interest_rate_used: 22.77,
              monthly_payment: 1025.98,
              principal: 35194,
              time_in_months: 57,
            },
          ],
        },
      ],
    },
    projected_increase: {
      estimated_debt: 30000,
      projected_debt: 35194,
      projected_increase: 5194,
      rounded_estimated_debt: 30000,
    },
  },
}

export const datWaitPropsBase = {
  title: "Don't Wait!",
  beginningLine: 'If you wait 3 months, you are estimated to pay',
  endingLine: 'to get rid of your debt.',
  totalDebt: 2300,
  moreEachMonth: 57,
  moreMonthsToBeDebtFree: 4,
  linkHref: '/',
  linkText: 'Explore debt solutions',
  showWaitTime: true,
  onClick: () => {},
}

export function monthsToYears(months) {
  // Validate input: must be a number
  const validMonths = typeof months === 'number' && !isNaN(months) ? months : 0

  // Convert months to years
  const years = validMonths / 12

  // Return the value rounded to the nearest whole number
  return `${Math.round(years)} yr`
}

export const graphPropsBase = {
  graphHeight: 350,
  data: DataSectionTest,
  textLegendAxisY: 'TOTAL',
  subtextLegendAxisY: 'COST',
  achieveLogo:
    'https://images.ctfassets.net/80jeq2aeq4l1/1h9tWFoBq4p7v3Y9c9HzXs/11bae295d59e2128f9143e4d95b61441/a_logo.svg?w=3840',
  tooltipTitleAchieve: 'achieve',
  tooltipPositionAchieve: 'left',
  tooltipTitleCurrent: 'Current',
  tooltipPositionCurrent: 'right',
  tooltipTitleWait: 'If you wait',
  tooltipPositionWait: 'middle',
  productType: 'AR',
  productTypeTerms: 0,
  simpleYaxis: false,
  colorGraph: '',
}

export const extractTableProps = (response, productType) => {
  const productToOfferMap = {
    AR: { name: 'ar_offers', index: 1 },
    PL: { name: 'apl_offers', index: 1 },
    HL: { name: 'ahl_offers', index: 0 },
  }
  const productTypeData = productToOfferMap[productType]
  const monthlyCurrent = numberFormatCurrency(
    Math.round(
      response?.current_assessment?.cfos?.payoff_plans?.[0]?.tradeline_payoff?.[0]?.monthly_payment
    )
  )
  const monthlyAchieve = numberFormatCurrency(
    Math.round(
      response?.default_offers?.[productTypeData.name]?.[productTypeData.index]?.monthly_payment
    )
  )
  const monthlySavings = numberFormatCurrency(
    parseInt(monthlyCurrent.split(',').join('').substring(1)) -
      parseInt(monthlyAchieve.split(',').join('').substring(1))
  )
  const totalCurrent = numberFormatCurrency(
    Math.round(response?.current_assessment?.cfos?.payoff_plans?.[0]?.total_amount)
  )
  const totalAchieve = numberFormatCurrency(
    Math.round(
      response?.default_offers?.[productTypeData.name]?.[productTypeData.index]?.total_cost
    )
  )

  const currentTime = monthsToYears(
    Math.round(response?.projected_assessment?.cfos?.payoff_plans?.[0]?.time_in_months)
  )

  const totalSavings = numberFormatCurrency(
    parseInt(totalCurrent.split(',').join('').substring(1)) -
      parseInt(totalAchieve.split(',').join('').substring(1))
  )

  return {
    monthlyCurrent,
    monthlyAchieve,
    monthlySavings,
    totalCurrent,
    totalAchieve,
    totalSavings,
    currentTime,
  }
}

export const extractWaitProps = (response) => {
  const projectedTime = response?.projected_assessment?.cfos?.payoff_plans?.[0]?.time_in_months
  const currentTime = response?.current_assessment?.cfos?.payoff_plans?.[0]?.time_in_months

  const monthlyCurrent = Math.round(
    response?.current_assessment?.cfos?.payoff_plans?.[0]?.tradeline_payoff?.[0]?.monthly_payment
  )
  const monthlyProjected = Math.round(
    response?.projected_assessment?.cfos?.payoff_plans?.[0]?.tradeline_payoff?.[0]?.monthly_payment
  )

  const totalAmount = Math.round(
    response?.current_assessment?.cfos?.payoff_plans?.[0]?.tradeline_payoff?.[0]?.amount
  )
  const projectedAmount = Math.round(
    response?.projected_assessment?.cfos?.payoff_plans?.[0]?.tradeline_payoff?.[0]?.amount
  )

  const waitProps = {
    totalDebt: projectedAmount - totalAmount,
    moreEachMonth: monthlyProjected - monthlyCurrent,
    moreMonthsToBeDebtFree: projectedTime - currentTime,
  }
  return waitProps
}

export const extractGraphProps = (response) => {
  const graphProps = {
    data: response,
  }
  return graphProps
}

export const numberFormatCurrency = (value) => {
  return '$' + new Intl.NumberFormat('en-US').format(value || 0)
}

export const numberFormatThousands = (value) => {
  return `${Math.round(value / 1000)}K`
}

export const defaultOffer = 'offer2'
// offer1 up to 24 months
// offer2 up to 48 months -> this should be set as default offer
// offer3 more than 48 months
